/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAccountLightDto } from './user-account-light-dto';


export interface LoginDetails { 
    loginResult?: LoginDetails.LoginResultEnum;
    roles?: Array<string>;
    userAccountLightDto?: UserAccountLightDto;
    username?: string;
}
export namespace LoginDetails {
    export const LoginResultEnum = {
        SecAuthorized: 'SEC_AUTHORIZED',
        SecNotAuthorized: 'SEC_NOT_AUTHORIZED',
        SecChangePwd: 'SEC_CHANGE_PWD',
        SecChangePwdAndQuestions: 'SEC_CHANGE_PWD_AND_QUESTIONS',
        SecAccountStatusProblem: 'SEC_ACCOUNT_STATUS_PROBLEM',
        SecPwdResetSent: 'SEC_PWD_RESET_SENT'
    } as const;
    export type LoginResultEnum = typeof LoginResultEnum[keyof typeof LoginResultEnum];
}


